import { IconCheck, IconX } from '@tabler/icons-react-native';
import { View } from 'react-native';
import { HubButton, hubColors, styles } from '../components';

import type { OfferHubState } from '../hooks';

export function OfferHubTutorialActions({
  swipeTutorialStep,
  swipeTutorialCard,
  t,
  fetchingRound,
  showError,
  setSwipeTutorialStep,
  startList,
}: Pick<
  OfferHubState,
  'swipeTutorialStep' | 'swipeTutorialCard' | 't' | 'fetchingRound' | 'showError' | 'setSwipeTutorialStep' | 'startList'
>) {
  return swipeTutorialStep === 1 || swipeTutorialStep === 2 ? (
    <View style={styles.buttonRow}>
      <HubButton
        testID="offer-hub-swipe-tutorial-reject"
        style={styles.flex}
        tone="outline"
        disabled={swipeTutorialStep === 1}
        prefix={<IconX size={24} color={hubColors.ink} />}
        onPress={() => swipeTutorialCard.current?.swipe('reject')}
      >
        {t('reject')}
      </HubButton>
      <HubButton
        testID="offer-hub-swipe-tutorial-accept"
        style={styles.flex}
        tone="teal"
        disabled={swipeTutorialStep === 2}
        prefix={<IconCheck size={24} color="#FFFFFF" />}
        onPress={() => swipeTutorialCard.current?.swipe('accept')}
      >
        {t('accept')}
      </HubButton>
    </View>
  ) : (
    <HubButton
      disabled={fetchingRound || showError}
      onPress={() => {
        if (swipeTutorialStep === 0) setSwipeTutorialStep(1);
        else void startList();
      }}
    >
      {t(swipeTutorialStep === 0 ? 'beginTutorial' : 'startList')}
    </HubButton>
  );
}
